import { useRef, useEffect } from "react";
import "./BlankApparelSection.css";

const BlankApparelSection = ({ data }: { data: any }) => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const isPausedRef = useRef(false);

  useEffect(() => {
    let animationFrame: number;
    const speed = 1;

    const scroll = () => {
      if (carouselRef.current) {
        if (!isPausedRef.current) {
          carouselRef.current.scrollLeft += speed;
        }

        if (
          carouselRef.current.scrollLeft >=
          carouselRef.current.scrollWidth - carouselRef.current.clientWidth
        ) {
          carouselRef.current.scrollLeft = 0;
        }
      }
      animationFrame = requestAnimationFrame(scroll);
    };

    animationFrame = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <section className="blank-apparel-section max-w-screen-xl mx-auto py-10">
      <h2 className="blank-apparel-title">{data?.header}</h2>
      <p className="blank-apparel-description">
        {data?.description
          ? data?.description
          : "We offer premium quality blank apparel perfect for custom prints, embroidery, or everyday wear. Choose from a wide range of styles and colors to match your vision."}
      </p>

      <div className="carousel-wrapper">
        <div className="carousel-container" ref={carouselRef}>
          {data?.products
            .concat(data?.products)
            .map((product: any, index: number) => (
              <div
                className="carousel-card"
                key={index}
                onMouseEnter={() => {
                  isPausedRef.current = true;
                }}
                onMouseLeave={() => {
                  isPausedRef.current = false;
                }}
              >
                <a
                  href={product?.price || "#"}
                  className="image-wrapper"
                >
                  <img
                    src={product?.image}
                    alt={product?.name}
                    className="product-image"
                  />
                  <img
                    src="/images/weMustLogo.png"
                    alt="logo"
                    className="product-logo"
                    style={{
                      top: product?.logoPosition?.top,
                      left: "4%",
                    }}
                  />
                </a>
                <div className="card-divider"></div>
                <div className="carousel-info">
                  <h3>{product.name}</h3>
                  {/* <p className="product-price" style={{marginBottom: "10px"}}>{product.price}</p>
                  <button className="hero-carousel-button hero-carousel-button-primary" style={{marginBottom: "10px"}}>View</button> */}
                </div>
                <hr className="card-divider" />
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default BlankApparelSection;
